import { render, staticRenderFns } from "./InvestigationEventChart.vue?vue&type=template&id=413f4a32&"
import script from "./InvestigationEventChart.vue?vue&type=script&lang=js&"
export * from "./InvestigationEventChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports